export default {
  styles: {
    a: {
      color: 'rgb(79, 80, 84)'
    },
    img: {
      width: 'auto',
      height: '300px'
    }, 
    ul: {
      width: '50%'
    },
    h1: {
      margin: '0'
    }, 
  },
      colors: {
        text: 'rgb(79, 80, 84)',
        background: 'rgb(223, 235, 242)',
      },
}